<script setup lang="ts">
import Footer from "@/components/identity/Footer.vue";
</script>

<template>
    <main class="p-8 flex flex-col gap-8 max-w-[1200px] mx-auto">
        <slot />
    </main>

    <Footer />
</template>
